import {getCustomShapeWorker} from '../../webworkers/helpers/customShape'
import {getImageDataFromCanvas} from '../../features/custom-shapes/fragment-detection/helpers/canvasToImageData'

/**
 * Loads image from src, runs fragment detection via Web Worker.
 * Throws if safe zone has thin regions.
 * @param {string} src - image URL or data URL
 * @returns {Promise<void>}
 */
export async function validateSafeZoneImage(src) {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.src = src
    await new Promise((resolve, reject) => {
        img.onload = resolve
        img.onerror = reject
    })

    const canvas = document.createElement('canvas')
    canvas.width = img.naturalWidth
    canvas.height = img.naturalHeight
    const ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0)
    const imageData = getImageDataFromCanvas(canvas)

    const worker = await getCustomShapeWorker()
    const fragments = await worker.detectFragments(imageData, {
        enableDetection: true,
    })

    const isInvalid = fragments.some((frag) => frag && frag.hasThinRegion && frag.minThicknessDetected)

    if (isInvalid) {
        throw new Error('Safe zone image has regions that are too thin to produce.')
    }
}
